import React, { useEffect, useState } from "react";

import i18next from "i18next";
import { Dropdown } from "semantic-ui-react";
import { useToasts } from "react-toast-notifications";
import { useCookies } from 'react-cookie';

const LanguageSelect = () => {

  const [selected, setselected] = useState()
  const { addToast } = useToasts();
  const [cookies, setCookie] = useCookies(['TGLang']);
  function showInfo() {
    try {

      let wlh = window.location.pathname;
      if (wlh === "/dashboard") {
        addToast("Brak tłumaczenia dla panelu administracyjnego..., Tłumaczenie obecnie jest tylko dla uczestników...", { appearance: 'info' });
      }
    } catch (error) {

    }

  }

  useEffect(() => {
    let tmpselected = "pl";
    if (cookies.TGLang) {
      tmpselected = cookies.TGLang
    }
    /*
    if(localStorage.getItem("i18nextLng").indexOf("pl")>=0){
      tmpselected = "pl";
    }else if(localStorage.getItem("i18nextLng")){
      //tmpselected = "gb";
      tmpselected = "pl";
    }else{
      tmpselected = "pl";
    }*/
    i18next.changeLanguage(tmpselected);
    setselected(tmpselected)
    return () => { }; // use effect cleanup to set flag false, if unmounted
  }, [])// eslint-disable-line react-hooks/exhaustive-deps

  const languages = [
    {
      key: 'pl',
      text: '',
      value: 'pl',
      flag: { name: "pl" },
    },
    {
      key: 'en',
      text: '',
      value: 'en',
      flag: { name: "gb" },
    }
  ]

  const handleClick = (e, { value }) => {
    showInfo()
    setselected(value)
    i18next.changeLanguage(value);
    let expiresdate = new Date();
    let today = new Date();
    expiresdate.setDate(today.getDate() + 30);
    setCookie('TGLang', value);
  };

  return (
    <div style={{ marginLeft: 10, marginRight: 3 }}>

      <Dropdown
        inline
        options={languages}
        value={selected}
        onChange={handleClick}
      />

    </div>
  );
};

export default LanguageSelect;  